import { PLAN_TYPE_ORDER } from "../consts"
import { planDeserializer } from "../helpers/planHelpers"
import { Plan, PlanType, ProductName, ServiceName } from "../interfaces"
import api from "../lib/api"

export const loadPlans = async (serviceName: ServiceName): Promise<Plan[]> => {
  const res = await api<any>(
    "get",
    `stripe/products?service_name=${serviceName}`,
  )

  // プラン名をここに直接並べない。並べていたせいで案C の starter が抜け、
  // CLOUD の一覧が 5 プランではなく 4 プランで出ていた。
  // そのサービスに存在しないプランは planDeserializer が undefined を返す。
  return PLAN_TYPE_ORDER.map((planType) =>
    planDeserializer(res.data, planType),
  ).filter((plan): plan is Plan => !!plan)
}

type SubscribePlanProps = {
  teamId: string
  planName: PlanType
  serviceName: ServiceName
}

export const subscribePlan = async (props: SubscribePlanProps) => {
  return await api<any>("post", `teams/${props.teamId}/subscriptions`, {
    plan_name: props.planName,
    service_name: props.serviceName,
  })
}

type SubscribeItemProps = {
  teamId: string
  productName: ProductName
  serviceName: ServiceName
}

export const subscribeItem = async (props: SubscribeItemProps) => {
  return await api<any>("post", `teams/${props.teamId}/quotas`, {
    quota_name: props.productName,
    service_name: props.serviceName,
    quota_action: "increase",
    quota_value: 1,
  })
}
